import * as React from "react";
import { HEADING_VARIANTS, List, ListItem, LIST_VARIANTS } from "@puregym/ui";
import { NavWrapper, NavHeading, NavLink } from "./styles";
import { NavDataType } from "./types";

const FooterNav = ({ navData }: { navData: NavDataType }) => (
  <NavWrapper>
    {navData.map((navGroup, index) => {
      const groupName = navGroup.name?.toLowerCase().replace(/\s/g, "-");
      const sectionId = `${groupName}-${index}`;

      return (
        <section key={sectionId}>
          <NavHeading
            as="span"
            id={sectionId}
            variant={HEADING_VARIANTS.EPSILON}
          >
            {navGroup.name}
          </NavHeading>
          {navGroup.navigationItems && (
            <List aria-labelledby={sectionId} variant={LIST_VARIANTS.PLAIN}>
              {navGroup.navigationItems.map(
                (item, index) =>
                  item.to && (
                    <ListItem key={`${item}${index}`}>
                      <NavLink href={item.to}>{item.name}</NavLink>
                    </ListItem>
                  )
              )}
            </List>
          )}
        </section>
      );
    })}
  </NavWrapper>
);

export default FooterNav;
